import { useConnection } from "@solana/wallet-adapter-react";
import { convert } from "@stepfinance/common";
import { useEffect, useState } from "react";

export const useRent = (rentDataLength: number) => {
  const { connection } = useConnection();
  const [accountRent, setAccountRent] = useState(0);
  const [isRentLoading, setIsRentLoading] = useState(true);

  useEffect(() => {
    const searchAccountRent = async () => {
      setIsRentLoading(true);
      const rent = convert(await connection.getMinimumBalanceForRentExemption(rentDataLength), 9);
      setAccountRent(rent);
      setIsRentLoading(false);
    };
    void searchAccountRent();
  }, [connection, rentDataLength]);

  return { isRentLoading, accountRent };
};
